<template>

  <div>

    <b-card>

      <h2 class="mb-2">
        Search Filter
      </h2>

      <!-- Table Top -->
      <b-row>
        <!-- <b-col
          cols="12"
          md="4"
          class="w-100"
        >
          <v-select
            v-model="filterDataStatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterStatusOptions"
            :clearable="false"
            :placeholder="'Select Status'"
          />
        </b-col> -->

        <b-col
          cols="12"
          md="4"
          class="w-100"
        >
          <v-select
            v-model="filterDataInstance"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="filterInstanceOptions"
            :clearable="false"
            label="name"
            :reduce="option => option.id"
            :placeholder="'Select Instance'"
          />
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <div class="d-flex align-items-center">
            <b-button
              class="ml-1"
              variant="primary"
              @click="clearFilters"
            >
              <span class="mr-25 align-middle">Reset filters</span>
            </b-button>
          </div>
        </b-col>
      </b-row>

    </b-card>

    <!-- Table Container Card -->
    <b-card
      no-body
    >

      <div class="table-header m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="mr-1 mb-0">Show</label>
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :value="perPage"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
              @input="updatePerPage"
            />
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <label class="mr-1 mb-0">Search</label>
              <b-form-input
                v-model="searchQuery"
                placeholder="Search"
                class="w-25"
              />

              <b-button
                class="ml-1"
                variant="primary"
                :to="{ name: 'admin-user-add' }"
              >
                <span class="mr-25 align-middle">Create User</span>
              </b-button>

              <b-button
                class="ml-1"
                variant="primary"
                :disabled="isLoading"
                @click="exportUsersCSV"
              >
                <b-spinner
                  v-if="isLoading"
                  small
                />
                <span
                  class="ml-25 align-middle"
                >Export Admins</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refInvoiceListTable"
        :items="fetchAdminsList"
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
      >
        <!-- Loader -->
        <template #table-busy>
          <TableSpinner />
        </template>

        <!-- Column: name -->
        <template #cell(name)="data">
          <b-avatar
            class="mr-1"
            size="32"
            :src="data.item.avatar"
          />
          <b-link
            :to="{ name: 'admin-profile', params: { id: data.item.id } }"
          >{{ data.item.fullName }}</b-link>
        </template>

        <!-- Column: instance -->
        <template #cell(instance)="data">
          {{ userSchools(data.item) }}
        </template>

        <!-- Column: last_login -->
        <template #cell(last_login)="data">
          <b-badge
            :variant="`light-primary`"
          >
            {{ data.value }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">

          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="mx-auto p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-for="option in actionOptions"
              :key="option.value"
              :to="{ name: option.link, params: { id: data.item.id } }"
            >
              <span>{{ option.title }}</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="userData.is_super_admin"
              @click="deleteItem(data.item.id)"
            >
              <span>Delete User</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-if="totalItems"
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>

  </div>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination, BLink, BButton,
  BDropdown, BDropdownItem, BAvatar, BBadge, BSpinner,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import axios from '@axios'
import { downloadExportFile } from '@core/mixins/downloadExportFile'
import vSelect from 'vue-select'
import store from '@/store'
import storeModule from '@/views/admin/admins/adminsStoreModule'
import useAdminsList from '@/views/admin/admins/admins-list/useAdminsList'
import TableSpinner from '@/views/components/table-spinner/TableSpinner.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BBadge,
    BLink,
    BButton,
    BSpinner,

    vSelect,

    TableSpinner,
  },
  mixins: [downloadExportFile],
  data() {
    return {
      filterStatusOptions: ['Active', 'Inactive'],
      filterInstanceOptions: [],
      isLoading: false,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  setup(props, { root }) {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-admins'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const {
      fetchAdminsList,
      fetchInstancesList,
      exportAdmins,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalItems,
      searchQuery,
      filterDataStatus,
      filterDataInstance,
      sortBy,
      dataMeta,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,
      actionOptions,

      refetchData,

      resolveStatusVariant,
      clearFilters,
    } = useAdminsList(root)

    return {
      fetchAdminsList,
      fetchInstancesList,
      exportAdmins,
      tableColumns,
      perPage,
      perPageOptions,
      currentPage,
      totalItems,
      sortBy,
      searchQuery,
      filterDataStatus,
      filterDataInstance,
      dataMeta,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,
      actionOptions,

      refetchData,

      resolveStatusVariant,
      clearFilters,
    }
  },
  watch: {
    $route() {
      if (!this.$route.query.currentPage) {
        this.setFilterParams()
      }
      this.refetchData()
    },
  },
  async created() {
    this.setFilterParams()
    // Update filters
    window.onpopstate = () => {
      this.setFilterParams()
    }
    this.filterInstanceOptions = await this.fetchInstancesList()
  },
  methods: {
    async deleteItem(ID) {
      await axios
        .delete(`auth/admins/${ID}`)
        .then(() => {
          this.refetchData()
        })
        .catch(error => error)
    },
    userSchools(user) {
      return user.schools.map(item => item.name).join(', ')
    },
    async exportUsersCSV() {
      const queryParams = {
        sortBy: 'name',
        sortDesc: 0,
        role: 'admin',
      }
      this.isLoading = true

      await this.exportAdmins(queryParams).then(response => {
        if (response.status === 200) {
          this.downloadFile(response.data, 'Admins', 'csv')
          this.isLoading = false
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    updatePerPage(val) {
      localStorage.setItem('adminsPerPage', val)
      this.perPage = val
    },
    setFilterParams() {
      const query = { ...this.$route.query }
      const defaultPerPage = Number(localStorage.getItem('adminsPerPage'))
      this.currentPage = Number(query.currentPage) || 1
      this.perPage = Number(query.perPage) || defaultPerPage || 10
      this.searchQuery = query.searchQuery || ''
      // this.filterDataInstance = query.filterDataInstance || null
    },
  },
}
</script>

<style lang="scss" scoped>
  .table-header {

    label {
      margin-bottom: 0;
    }
  }

  .badge {
    text-transform: uppercase;
  }

  .per-page-selector {
    width: 90px;
  }

  .invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
